// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from 'react';

const Favorite: React.FC = ()=>(
<svg  focusable="false" width="13" height="13" viewBox="0 0 13 13" >
    <path fill="currentColor" d="M6.748.5a.56.56 0 0 1 .506.316l1.608 3.312 3.59.53a.565.565 0 0 1 .314.956l-2.603 2.583.614 3.647a.564.564 0 0 1-.82.59L6.746 10.72l-3.207 1.713a.56.56 0 0 1-.593-.04.57.57 0 0 1-.227-.55l.614-3.647L.73 5.615a.561.561 0 0 1 .314-.957l3.59-.53L6.243.816A.56.56 0 0 1 6.748.5m0 1.852-1.23 2.536a.57.57 0 0 1-.425.311l-2.772.408 2.013 1.995c.129.128.19.311.16.492l-.477 2.805 2.466-1.317a.56.56 0 0 1 .53 0l2.465 1.317-.473-2.803a.56.56 0 0 1 .16-.492l2.013-1.995-2.773-.41a.57.57 0 0 1-.424-.311z"/>
</svg>
);

export default React.memo(Favorite);
